import React, { Component } from "react";

class DateField extends Component {
  constructor(props) {
    super(props);
  }

  getDateLimitProps() {
    const { dateLimit } = this.props;
    if (!dateLimit) return {};

    const today = new Date().toISOString().split("T")[0];

    switch (dateLimit.type) {
      case "afterToday":
        return { min: this.addDays(today, 1) };
      case "beforeToday":
        return { max: this.addDays(today, -1) };
      case "after":
        return { min: dateLimit.date };
      case "before":
        return { max: dateLimit.date };
      case "between":
        return { min: dateLimit.minDate, max: dateLimit.maxDate };
      default:
        return {};
    }
  }

  addDays(dateStr, days) {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
  }

  render() {
    const {
      register,
      errors,
      label,
      name,
      rules,
      className,
      labelClassName,
      labelStyles,
      styles,
    } = this.props;

    const dateLimitProps = this.getDateLimitProps();

    return (
      <>
        <div
          className={`flex-col items-start ${
            this.props.hide ? "hidden" : "flex"
          } ${className}`}
        >
          <label
            className={`form-label font-bold float-start mb-1 ${labelClassName}`}
            style={labelStyles}
          >
            {rules?.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="date"
            style={styles}
            className="block w-full border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 p-1"
            {...dateLimitProps}
          />
          {errors[name] && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }
}

export default DateField;
